import { Typography } from 'gu-ui-kit'
import React, { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import DoubleFAForm from 'modules/Forms/Auth/DoubleFA'
import { Helmet } from 'react-helmet'
import { useHistory } from 'react-router'
import useGeneratePathI18n from 'utils/hooks/useGeneratePathI18n'
import { ROUTES } from 'constants/routes'

const DoubleFA = () => {
  const { t } = useTranslation()

  const history = useHistory()
  const pathGen = useGeneratePathI18n()

  const handleCancel = useCallback(
    () => history.push(pathGen(ROUTES.AUTH_LOGIN)),
    [],
  )

  return (
    <>
      <Helmet defer={false}>
        <title>{t('auth::2fa.title')}</title>
      </Helmet>
      <Typography
        className={'margin-bottom-40'}
        component={'h1'}
        variant={'Body-Accent-40'}
        color={'Label-Fifth'}
      >
        {t('auth::2fa.title')}
      </Typography>

      <DoubleFAForm onCancel={handleCancel} />
    </>
  )
}

export default DoubleFA
